import hasAccess from "@api/hasAccess"
import { useStore } from "@stores"
import { useAppContext } from "@components/AppContext"

export const indexOperation = "transactions/IndexFailedTransactions"


const useFailedTransactionsStore = () => {
  const { request, identity } = useAppContext()
  const { id: organizationId } = identity.organization

  const canReadTransactions = hasAccess(['transactions-read'])
  const shouldAutoLoad = canReadTransactions

  const {
    items: failedTransactions,
    indexItems: indexFailedTransactions
  } = useStore(indexOperation, request, shouldAutoLoad, {}, [ organizationId ])

  return {
    failedTransactions,
    indexFailedTransactions,
  }
}

export default useFailedTransactionsStore
